// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--3WUvO","grid":"styles-module--grid--pE1MG","speechContainer":"styles-module--speech-container--2hoNu"};